import React from 'react';
import ASegmentedControl from 'antd-mobile/lib/segmented-control';



export default class SegmentedControl extends ASegmentedControl {}